import React, { useEffect, useState } from "react";
import { Button, Col, Flex, Form, Grid, Input, Row, Select, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faUser, faPencilAlt, faEye } from "@fortawesome/free-solid-svg-icons";
interface ChildComponentProps {
  showForm: boolean;
}
const { Option } = Select;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid; // Correct way to use it
export const ProfileDetails: React.FC<ChildComponentProps> = () => {
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 24,
        offset: 0,
      },
    },
  };
  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    console.log("Received values of form: ", values);
  };
  const logoAlignmentOption = [
    { label: "Left", value: "left" },
    { label: "Center", value: "center" },
    { label: "Right", value: "right" },
  ];
  const [value1, setValue1] = useState("left");
  const [showForm, setShowForm] = useState(false); // Toggle state

  const handleToggle = () => {
    setShowForm((prev) => !prev);
  };
  const screens = useBreakpoint();
  return (
    <>
      <Button className="d-flex ml-auto mb-3" type="primary" onClick={handleToggle}>
        {showForm ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faPencilAlt} />}
      </Button>
      {showForm ? (
        <Form
          {...formItemLayout}
          form={form}
          name="register"
          onFinish={onFinish}
          className="mainCardDetailsForm py-4"
          initialValues={{
            residence: ["zhejiang", "hangzhou", "xihu"],
            prefix: "86",
          }}
          scrollToFirstError
        >
          <Form.Item
            name="travelAgencyName"
            label="Travel Agency Name"
            className="cardTextfieldBox residentBox"
            rules={[{ required: true, message: "Please select Residence!" }]}
          >
            <Input
              suffix={<FontAwesomeIcon icon={faUser} />}
              style={{ width: "100%" }}
              className="cardInputfield"
            />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="website"
            label="Website"
          >
            <Input style={{ width: "100%" }} className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="zipCode"
            label="Zip Code"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="agentName"
            label="Agent Name"
            rules={[
              { required: true, message: "Please input your phone number!" },
            ]}
          >
            <Input style={{ width: "100%" }} className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="followUpPhoneNumber"
            label="Select Country"
            rules={[
              { required: true, message: "Please input your phone number!" },
            ]}
          >
            <Select placeholder="select Nationality" className="cardInputfield">
              <Option value="male">Saudi Arabia</Option>
              <Option value="female">Dubai</Option>
              <Option value="other">UAE</Option>
            </Select>
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="selectCity"
            label="Select City"
          >
            <Select placeholder="select Nationality" className="cardInputfield">
              <Option value="male">Saudi Arabia</Option>
              <Option value="female">Dubai</Option>
              <Option value="other">UAE</Option>
            </Select>
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="selectPosition"
            label="Select Position"
          >
            <Select placeholder="select Nationality" className="cardInputfield">
              <Option value="male">Saudi Arabia</Option>
              <Option value="female">Dubai</Option>
              <Option value="other">UAE</Option>
            </Select>
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="selectCurrency"
            label="Select Currency"
          >
            <Select placeholder="select Nationality" className="cardInputfield">
              <Option value="male">Saudi Arabia</Option>
              <Option value="female">Dubai</Option>
              <Option value="other">UAE</Option>
            </Select>
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="emailAddress"
            label="Email Address"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="confirmEmailAddress"
            label="Confirm Email Address"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="skypeID"
            label="Skype ID"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="whatsappNumber"
            label="Whatsapp Number"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox w-44"
            name="address"
            label="Address"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="mobileNumber"
            label="Mobile Number"
          >
            <Select placeholder="select" className="cardInputfield">
              <Option value="male">Cash</Option>
              <Option value="female">Cheque</Option>
              <Option value="other">DD</Option>
            </Select>
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="telephoneNumber"
            label="Telephone Number"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="tRNNumber"
            label="TRN Number"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Form.Item
            className="cardTextfieldBox"
            name="refundType"
            label="Refund Type"
          >
            <Input className="cardInputfield" />
          </Form.Item>

          <Flex className="w-100" justify="space-between">
            <div>
              <Title level={4} className="font-weight-400 mt-2 mb-1">
                Logo Alignment in your voucher/invoice
              </Title>
              <Flex gap={16}>
                {logoAlignmentOption.map((option) => (
                  <Flex
                    align="center"
                    key={option.value}
                    onClick={() => setValue1(option.value)}
                  >
                    <span
                      className="radioRoundCheck"
                      style={{
                        backgroundColor:
                          value1 === option.value ? "#F40508" : "transparent",
                      }}
                    >
                      {value1 === option.value && (
                        <CheckOutlined
                          style={{ color: "white", fontSize: "10px" }}
                        />
                      )}
                    </span>
                    {option.label}
                  </Flex>
                ))}
              </Flex>
            </div>
            <div>
              <Text className="font-weight-400 w-100 d-block">
                Logo Alignment in your voucher/invoice
              </Text>
              <Form.Item
                {...tailFormItemLayout}
                className="bottomButtonBox my-0"
              >
                <Button type="primary" htmlType="submit">
                  Save
                </Button>
              </Form.Item>
            </div>
          </Flex>

          {/* <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit">
          Register
        </Button>
      </Form.Item> */}
        </Form>
      ) : (
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={12}>
            <div className="border-8 bg-text font-14 w-100 p-4 mb-3">
              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"   style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>Agent Code :</span>
                  <span>AED 0.01</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"
                 style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}
                >
                  <span>Agent Name :</span>
                  <span> deepakparwani</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>Travel Agency Name :</span>
                  <span>deepak parwani</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }} justify="space-between">
                  <span>User Name :</span>
                  <span>deepak@booktoursindubai.com</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }} justify="space-between">
                  <span>Email Id :</span>
                  <span>deepak@booktoursindubai.com</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }} justify="space-between">
                  <span>Mobile Number :</span>
                  <span>568003993</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }} justify="space-between">
                  <span>Designation :</span>
                  <span>Travel Consultant</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }} justify="space-between">
                  <span>Website :</span>
                  <span>www.booktoursindubai.com</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }} justify="space-between">
                  <span>Logo Alignment :</span>
                  <span>Left</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }} justify="space-between">
                  <span>Refund Type :</span>
                  <span>Credit Limit</span>
                </Flex>
              </Title>
            </div>
          </Col>

          <Col xs={24} lg={12}>
            <div className="border-8 bg-text font-14 w-100 p-4 mb-3">
              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>STREET ADDRESS :</span>
                  <span>panoroma grand bur dubai</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>TOWN / CITY :</span>
                  <span>Dubai City</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>ZIP CODE :</span>
                  <span>0000</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>COUNTRY :</span>
                  <span>United Arab Emirates</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>TELEPHONE Number :</span>
                  <span>561919971</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>PREFERRED CURRENCY :</span>
                  <span>AED</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>SKYPE ID :</span>
                  <span>--</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>Whatsapp Number :</span>
                  <span>971561919971</span>
                </Flex>
              </Title>

              <Title level={5} className="font-weight-400 mt-2 mb-1">
                <Flex justify="space-between"  style={{
                  flexDirection: screens.lg ? "row" : "column",
                }}>
                  <span>TRN Number :</span>
                  <span></span>
                </Flex>
              </Title>
            </div>
          </Col>
        </Row>
      )}
      ;
    </>
  );
};

export default ProfileDetails;


